const languagePack = {
  _language: 'ru',
  Menu: {
    home: '',
    tournaments: 'Турниры',
    dashboard: 'Таблица',
    wallet: 'Кошелек',
    leadboard: 'Лидеры',
    settings: 'Настройки',
    referrals: 'Рефералы',
    more: 'Еще',
  },
  HomeMenu: {
    about: 'О нас',
    faq: 'ЧАВО',
    referrals: 'Рефералы',
    /*  */
    signIn: 'Войти',
    signUp: 'Зарегистрироваться',
  },
  Dashboard: {
    balance: 'Баланс',
    refresh: 'Обновить',
  },
  User: {
    connected: 'Подключен',
  },
  Profile: {
    bonusLevel: 'Твой Бонус',
    boost: 'Повысить',
    boostMultiplier: 'Повысь свой коофициент бонусов прямо сейчас!',
  },
};

export default languagePack;
